module.exports = __webpack_public_path__ + "static/media/highlightOffering.5d1060ae.svg";